import gql from 'graphql-tag';

const SAVE_BULK_STAGE = gql`
  mutation Mutation($deviceSerialNos: [String!], $stage: String!) {
    bulkStage(deviceSerialNos: $deviceSerialNos, stage: $stage) {
      failed
    }
  }
`;

export default SAVE_BULK_STAGE;
